import React from 'react';
import { Modal as MuiModal, Box, Typography, IconButton } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import './Modal.css';

export interface ModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
  width?: string | number;
}

const Modal: React.FC<ModalProps> = ({
  open,
  onClose,
  title,
  children,
  width = 508,
}) => {
  return (
    <MuiModal
      open={open}
      onClose={onClose}
      className="custom-modal"
    >
      <Box
        className="modal-container"
        sx={{
          width: width,
        }}
      >
        {/* Modal Header */}
        <Box className="modal-header">
          <Typography className="modal-title">
            {title}
          </Typography>
          <IconButton
            className="modal-close-button"
            onClick={onClose}
          >
            <CloseIcon sx={{ fontSize: '24px' }} />
          </IconButton>
        </Box>

        {/* Modal Content */}
        <Box className="modal-content">
          {children}
        </Box>
      </Box>
    </MuiModal>
  );
};

export default Modal;

